import filter from './filter';
import details from './details';

export default {
  filter,
  details
};
